import { render } from "./StaffUpload.vue?vue&type=template&id=127172c8&scoped=true"
import script from "./StaffUpload.vue?vue&type=script&lang=js"
export * from "./StaffUpload.vue?vue&type=script&lang=js"

import "./StaffUpload.vue?vue&type=style&index=0&id=127172c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-127172c8"]])

export default __exports__